import axios from 'axios';
import { BACKEND_URL } from '@/lib/env';

const API = `${BACKEND_URL}/api/dashboard/sod-rules`;

export async function fetchSodRules() {
  const { data } = await axios.get(`${API}`);
  return data;
}

export async function importSodRules({ contentBase64, filename, actor }) {
  const { data } = await axios.post(`${API}/import`, {
    content_b64: contentBase64,
    filename,
    actor,
  });
  return data;
}

export async function fetchSodRulesAuditLog() {
  const { data } = await axios.get(`${API}/audit-log`);
  return data;
}

export async function exportSodRules(format = 'xlsx', actor = 'system') {
  const response = await axios.get(`${API}/export`, {
    params: { format, actor },
    responseType: 'blob',
  });

  const filename = `sod_rules_export.${format}`;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
